export enum ComponentType {
  Header = 'HEADER',
  Benefits = 'BENEFITS',
  CTA = 'CTA',
  Cost = 'COST',
  Disclaimer = 'DISCLAIMER',
  Documents = 'DOCUMENTS', // Descoped
  Features = 'FEATURES', // Not implemented but exists in Metadata.PDF
  Link = 'LINK',
  Summary = 'SUMMARY',

  // TODO: come back to when implementing product list endpoint
  Product = 'Product',
  ProductList = 'ProductList',
}

export enum RGBColorType {
  Text = 'text-color',
  SolidBackground = 'background-color',
  GradientBackground = 'background-color-gradient',
}

export type RGBColor = {
  name: string;
  type: RGBColorType;
  rgb1: string;
  rgb2: string;
};

export enum ComponentStyle {
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D',
  E = 'E',
  F = 'F',
  G = 'G',
  H = 'H',
}

export enum ProductClientId {
  VirginMoney = 'virgin-money',
  ThirdParty = 'third-party',
}

export enum ProductClientSource {
  ThirdParty = 'tp',
  VirginMoney = 'vm',
}

export type BulletPoint = {
  title: string;
  description?: string;
  item?: string;
  image?: string;
};

type ProductPrice = {
  amount: string;
  frequency: string;
};

export type ProductCTA = {
  buttonText: string;
  cta: string;
  isWhite?: boolean;
};

export type ProductClient = {
  source: ProductClientSource;
  id: string;
  isIntegrated: boolean;
};

export enum FileType {
  PDF = 'PDF',
  // TODO: add more file types
}

export type FileDownload = {
  name: string;
  type: FileType;
  url: string;
};

export type ProductComponent = {
  type: ComponentType;
  style: ComponentStyle;
  title: string;
  description?: string;
  image?: string;
  logo?: string;
  points?: BulletPoint[];
  price?: ProductPrice;
  cta?: ProductCTA;
  files?: FileDownload[];
  palette?: RGBColor[];
};

export const enum ProductCategory {
  LENDING = 'LENDING',
  SAVINGS = 'SAVINGS',
  THIRD_PARTY = 'THIRD-PARTY',
}

export type Product = {
  productId: string;
  client: ProductClient;
  category: ProductCategory;
  tags: string;
  components: ProductComponent[];
};

export type GetProductResponseBody = {
  product: Product;
};

// GET Product List

type ProductOffer = {
  offerText?: string;
  offerBadge?: string;
};

type ProductTile = {
  logo?: string;
  image?: string; // this is a second image for the tile
  description?: string;
  offer?: ProductOffer;
};

export enum ProductTileVMCategory {
  LENDING = 'LENDING',
  SAVINGS = 'SAVINGS',
  FOREIGN = 'FOREIGN',
}

export enum ProductTileTPCategory {
  ACCOUNTING = 'ACCOUNTING',
  PAYMENTS = 'PAYMENTS',
  HR = 'HR',
  TAX = 'TAX',
  INSURANCE = 'INSURANCE',
}

// This should match with the same type defined in temp-omega-local-server-webapp:
// temp-omega-local-server-webapp/api/products/types.ts#L117
export type ProductMetadata = {
  name?: string; // This needs not to be made optional
  category?: string;
  logo?: string;
  title: string;
  description: string;
  tile?: ProductTile; // this shouldn't be optional
  image: string;
  type: ComponentType;
  style?: ComponentStyle;
  cta: ProductCTA;
  price?: ProductPrice;
};

export type ProductOverview = {
  productId: string;
  metadata: ProductMetadata;
};

export type ProductListItem = {
  client: ProductClient;
  category: ProductCategory;
  tags: string;
  product: ProductOverview;
};

export type ProductList = {
  totalPages: number;
  pageNumber: number;
  itemsPerPage: number;
  products: ProductListItem[];
};

export type GetProductListResponseBody = {
  productlist: ProductList;
};

export type CategorisedProductListItem = {
  [category: string]: ProductListItem[];
};

export type MarketplaceLandingPageProducts = {
  data: Partial<ProductList>;
};

export type MarketplaceFilteredLendingProducts = {
  lending: ProductListItem[];
  spotlight: ProductListItem[];
};

export type CustomerDetails = {
  customer_id: string;
};

export type UserDetails = {
  customers: Array<CustomerDetails>;
  id: string;
};

export type MTrackConsent = {
  userDetails: UserDetails;
  whiteListConsent: boolean;
  clientConsent: boolean;
};

export enum TileTag {
  All = 'all',
}
